<template>
    <div class="fullcontainer preloadbgp1" style="background-image:url('res/p1/bg.png');">
      <!-- <img class="bt" src="res/p1/bt.png"> -->
      <div class="dt_cont">
        <div class='loading'>{{percent}}<span> %</span></div>
        <div class='desc'>正在进入数字产业园...</div>
      </div>


    </div> 
</template>

<script>
import { PICS } from "./PreloadD.js";

import { CONFS } from "./animateconf.js";

for (let key in CONFS) {
  let conf = CONFS[key];
  let pagesize = conf.pagesize ? conf.pagesize : 50;
  let n = Math.ceil(conf.totalFrames / pagesize);
  for (let i = 1; i <= n; i++) {
    PICS.push({ path: `res/aniAndAud/${key}/${i}.png` });
  }
}

import { loadImg } from "@/d.js";
// import { clearInterval } from 'timers';

export default {
  data() {
    return {
      percent: "0"
    };
  },
  mounted() {
    let that = this;
    window.addEventListener("load", ()=>{
      that._mounted();
    });
  },
  
  beforeDestroy() {},

  methods: {
    _mounted() {
    let i = -1;
    let that = this;
    let complete = false;
    let ti = 0;
    function LoadPic() {
      if (i >= PICS.length - 1) {
        if (!complete) {
          that.$root.$emit("SwitchTo", "P1");
          complete = true;
        }

        // window.console.log(i, PICS.length);
        return;
      }
      i++;
      // let ti = i;
      loadImg(PICS[i].path, () => {
        ti++;
        that.percent = (ti / PICS.length * 100).toFixed(0);
        // window.console.log(ti, PICS.length, PICS[i].path);
        LoadPic();
      });
    }

    let tt = 0;
    let timeid = setInterval(() => {
      // window.console.log("dd", Date.now());
      LoadPic();
      if (tt == 2) return clearInterval(timeid);
      tt++;
    }, 100);
  },
  }
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.preloadbgp1 {
  @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");
  .dt_cont {
    position: relative;
    top: 38%;
    @include horizontalCenterPercent(90%);
    color: white;
    .loading {
      // @include horizontalCenterPercent(100%);
      // text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;
      text-align: center;
      font-size: 0.35rem;
    }
    .desc {
      position: relative;
      top: 0.4rem;
      // @include horizontalCenterPercent(100%);
      text-align: center;
      font-size: 0.25rem;
      // color: black;
    }
  }
}
</style>
